export default __webpack_public_path__ + "static/media/shop-signup.717c6096.png";